import { useState, type VoidFunctionComponent } from 'react';

import Accordion from '../../generic/Accordion';
import Card from '../../generic/Card/Card';
import Flex from '../../generic/Flex';

import DeleteAllProjectsCard from './DeleteAllProjectsCard';

type Props = {
  isOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
};

export const DangerZoneCard: VoidFunctionComponent<Props> = ({ isOpen, onToggle }) => {
  const [isSectionOpen, setIsSectionOpen] = useState(isOpen ?? false);
  const handleToggle = () => {
    setIsSectionOpen(!isSectionOpen);
    onToggle?.(isSectionOpen);
  };

  return (
    <Card isFullWidth padding="medium" variant="fill" color="pink">
      <Card.Content>
        <Accordion id="danger-zone" isInitiallyOpen={isSectionOpen}>
          <Accordion.Target onClick={handleToggle}>Danger Zone</Accordion.Target>
          <Accordion.Body>
            <div>
              Changes in this section will have immediate, irreversible deletion effects.
            </div>
            <Flex direction="column" gap={12}>
              <DeleteAllProjectsCard />
            </Flex>
          </Accordion.Body>
        </Accordion>
      </Card.Content>
    </Card>
  );
};
